import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from './approuter';
import Maintenance from './components/Maintenance';
import reportWebVitals from './reportWebVitals';

const isMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

ReactDOM.render(
  isMaintenance ? <Maintenance /> : <AppRouter />,
  document.getElementById('root')
);
/*
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
*/
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
